/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imagesUpdateMetadata } from "../../funcs/imagesUpdateMetadata.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateImageMetadataRequest$inboundSchema,
};

export const tool$imagesUpdateMetadata: ToolDefinition<typeof args> = {
  name: "images-update-metadata",
  description: `Replace the metadata for an existing image.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await imagesUpdateMetadata(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
